<template>
  <v-form>
    <v-row dense>
      <v-col cols="6">
        <v-text-field name="outsourcedProductName" outlined dense label="Product Name" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field name="outsourcedQuantity" outlined dense label="Quantity" v-model="record.Quantity"></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="outsourcedBuyingPrice"
          outlined
          dense
          label="Buying Price"
          v-model="record.BuyingPrice"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="outsourcedSellingPrice"
          outlined
          dense
          label="Selling Price"
          v-model="record.SellingPrice"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="outsourcedGrossProfit"
          outlined
          dense
          filled
          readonly
          label="Gross Profit"
          v-model="GrossProfit"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="outsourcedCommission"
          outlined
          dense
          label="Commission"
          v-model="record.Commission"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="outsourcedNetProfit"
          outlined
          dense
          filled
          readonly
          label="Net profit"
          v-model="NetProfit"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  computed: {
    NetProfit() {
      let data = this.record;
      let Commission = 0;
      if (data.Commission) {
        Commission = parseFloat(data.Commission);
      }
      let Profit = 0;
      let GrossProfit = 0;
      GrossProfit = this.GrossProfit;
      Profit = GrossProfit - Commission;
      return Profit;
    },
    GrossProfit() {
      let Profit = 0;
      let data = this.record;
      let BuyingPrice = 0;
      let SellingPrice = 0;
      let Quantity = 0;
      if (data.BuyingPrice) {
        BuyingPrice = parseFloat(data.BuyingPrice);
      }
      if (data.SellingPrice) {
        SellingPrice = parseFloat(data.SellingPrice);
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      }
      Profit = Quantity * (SellingPrice - BuyingPrice);
      return Profit;
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    sendData() {
      this.loader = true;
      this.$emit("data", this.record);
    }
  },
};
</script>